// -----------------------------------------------------------------------------
// Allgemeines JS für Seiten
// -----------------------------------------------------------------------------

const init = () => {
  initEventListeners();
};

/**
 * Event-Listeners einrichten
 */
const initEventListeners = () => {
  // Navbar: Button wechseln
  $('.aws-navbar__toggle').on('click', function () {
    if ($('.aws-navbar__collapse').hasClass('show')) {
      $('.aws-navbar__toggle').stop().removeClass('is--active');
    } else {
      $('.aws-navbar__toggle').stop().addClass('is--active');
    }
  });

  // Zurück-Link
  $('.js-backlink').click(function () {
    window.history.go(-1);
  });

  // Passwort-Anforderungen prüfen
  if ($('.js-body').find('.js-app-admin-user-new-password').length) {
    checkPasswordRequirements();
  }
};

/**
 * Passwort-Anforderungen prüfen
 */
const checkPasswordRequirements = () => {
  const $container = $('.js-app-admin-user-new-password');
  const basepath = $('.js-body').attr('data-basepath');
  const url = `${basepath}/misc/password_requirements`;
  const $formPw1 = $container.find('#form_pw1');
  const $formPw2 = $container.find('#form_pw2');
  const $button = $container.find('.js-button');
  const minLength = $formPw1.attr('data-min-length');
  const $spinner = $container.find('.js-spinner');
  const $pwRequirements = $container.find('.js-password-requirements');
  const msgError = '<p class="text-danger">Passwort kann derzeit nicht geändert werden. Bitte Admin benachrichtigen.</p>';

  $spinner.show();

  let currentRequest = null;

  // Initialer Request
  $.ajax({
    type: 'POST',
    url: url,
    data: { minLength },
    statusCode: {
      500: () => {
        $pwRequirements.html(msgError);
      }
    },
    success: (data) => {
      $pwRequirements.html(data.html);
    },
    complete: () => {
      $spinner.hide();
    }
  });

  // Request bei User-Eingabe
  $('input').on('keyup', () => {
    $spinner.show();
    const pw1 = $formPw1.val();
    const pw2 = $formPw2.val();

    currentRequest = $.ajax({
      type: 'POST',
      data: { pw1, pw2, minLength },
      url: url,
      statusCode: {
        500: () => {
          $pwRequirements.html(msgError);
        }
      },
      beforeSend: () => {
        if (currentRequest !== null) {
          currentRequest.abort();
        }
      },
      success: (data) => {
        $pwRequirements.html(data.html);
        $button.prop('disabled', !data.status);
      },
      complete: () => {
        $spinner.hide();
      }
    });
  });
};

export {
  init
};
